import { useLegalCopy } from './useLegalCopy';

export function LegalCopy({
  className = '',
  forceLegalLinks = false,
}: {
  className?: string;
  forceLegalLinks?: boolean;
}) {
  const { acceptTermsText } = useLegalCopy({ forceLegalLinks });
  return <p className={`R12 contrast-low ${className}`}>{acceptTermsText}</p>;
}
